import ActionTypes from './types'
import {listBuildingStaffForBuilding, loadAllBuildingsAtOrganization, updateOrganization} from '../lib/queries'

/**
 * @param {Dispatch} dispatch
 * @param {string} organizationId
 * @return {Promise<void>}
 */
export async function setGlobalAdminOrganizationId(dispatch, organizationId) {
  dispatch({
    type: ActionTypes.GLOBAL_ADMIN_SET_ORGANIZATION_ID,
    payload: organizationId,
  })

  const buildings = await loadAllBuildingsAtOrganization(organizationId)

  dispatch({
    type: ActionTypes.GLOBAL_ADMIN_SET_BUILDINGS_LIST,
    payload: buildings,
  })
}

/**
 * @param {Dispatch} dispatch
 * @param {*} document
 * @param {Array<string>} buildingIds
 * @return {void}
 */
export function updateDocumentAndAssociatedBuildings(dispatch, document, buildingIds) {
  dispatch({
    type: ActionTypes.GLOBAL_ADMIN_UPDATE_DOCUMENT_AND_ASSOCIATED_BUILDINGS,
    payload: {document, buildingIds},
  })
}

/**
 * @param {Dispatch} dispatch
 * @param {string} documentId
 * @return {void}
 */
export function removeDocumentAndAssociatedBuildings(dispatch, documentId) {
  dispatch({
    type: ActionTypes.GLOBAL_ADMIN_REMOVE_DOCUMENT_AND_ASSOCIATED_BUILDINGS,
    payload: documentId,
  })
}

/**
 * @param {Dispatch} dispatch
 * @param {Array<string>} buildingIds
 * @return {Promise<void>}
 */
export async function loadStaffAtOrganization(dispatch, buildingIds) {
  const allStaffResults = await Promise.all(buildingIds.map(bId => listBuildingStaffForBuilding(bId)))

  // don't show deleted staff users or vendors
  const flattenedStaff = allStaffResults.flat().filter(bS => !bS.isDisabled && bS.staff.permissionGroup !== 'vendor')

  dispatch({
    type: ActionTypes.GLOBAL_ADMIN_SET_STAFF,
    payload: flattenedStaff, // these are BuildingStaff fragments with a .staff property
  })
}

/**
 * Updates organization ownerIds in state.
 * @param {Dispatch} dispatch
 * @param {*} organization
 * @param {string} staffId
 * @param {boolean} makeOwner
 * @return {Promise<void>}
 */
export async function updateOrganizationOwnerIdsInState(dispatch, organization, staffId, makeOwner = false) {
  if (!organization || !staffId) return

  let newOwnerIds = [...organization.ownerIds]
  if (makeOwner) {
    if (!newOwnerIds.includes(staffId)) {
      newOwnerIds.push(staffId)
    }
  } else {
    newOwnerIds = newOwnerIds.filter(id => id !== staffId)
  }

  try {
    await updateOrganization({id: organization.id, ownerIds: newOwnerIds})
    dispatch({
      type: ActionTypes.GLOBAL_ADMIN_UPDATE_ORGANIZATION_OWNER_IDS,
      payload: {
        organizationId: organization.id,
        newOwnerIds: newOwnerIds,
      },
    })
  } catch (err) {
    console.error('Failed to update organization ownerIds:', err)
    window.alert('Failed to update organization ownerIds: ' + (err.message || err))
  }
}
